export const isTrelloConnected = (entity?: {
  trello_connected?: boolean;
} | null) => Boolean(entity?.trello_connected);

export const isUpworkConnected = (entity?: {
  upwork_connected?: boolean;
} | null) => Boolean(entity?.upwork_connected);

export const isFortnoxConnected = (entity?: {
  fortnox_connected?: boolean;
} | null) => Boolean(entity?.fortnox_connected);
